import { Settings } from '~/common/entities/Settings/SettingsTypes';
import { useAuthenticationService } from './AuthenticationService';
import { ApiErrorCallback, ApiSuccessCallback } from './callback';
import { authenticatedApi } from '../utils/authenticatedApi';
import { createContainer } from 'unstated-next';
import { useMemo, useState } from 'react';
import moment from 'moment';

moment.updateLocale('de', {
  longDateFormat: {
    LLLL: 'dd Do',
  } as any,
});

moment.updateLocale('en', {
  longDateFormat: {
    LLLL: 'dd Do',
  } as any,
});

function useSettings() {
  const [settings, setSettings] = useState<Settings>({});
  const [loading, setLoading] = useState(false);

  const { authenticationState } = useAuthenticationService();
  const writeToStorage = (settings: Settings) => {};

  const getSettingsFromServer = async (
    onSuccess?: ApiSuccessCallback<Settings>,
    onError?: ApiErrorCallback,
  ) => {
    const { data, error } =
      await authenticatedApi(authenticationState).get<Settings>('/settings/');
    if (error) return onError ? onError(error) : undefined;
    if (data) {
      moment.locale(data.language);
      writeToStorage(data);
      setSettings(data);
    }
    if (data && onSuccess) {
      onSuccess(data);
    }
    setLoading(false);

    return undefined;
  };

  const loadSettingsFromStorage = () => {};

  const changeSettings = async (
    settings: Settings,
    onSuccess?: ApiSuccessCallback<Settings>,
    onError?: ApiErrorCallback,
  ) => {
    const { data, error } = await authenticatedApi(authenticationState).put<
      Settings,
      Settings
    >('/settings/', settings);

    if (error && onError) onError(error);
    if (data) {
      writeToStorage(data);
      setSettings(data);
      moment.locale(data.language);
    }
    if (data && onSuccess) {
      onSuccess(data);
    }
  };

  return {
    language: settings.language,
    loadSettingsFromStorage,
    getSettingsFromServer,
    loading,
    changeSettings,
  };
}

export const { Provider: SettingsProvider, useContainer: useSettingsService } =
  createContainer(useSettings);
